<template>
  <div class="production-list">
    <v-card >

        <v-app-bar flat >
          <v-icon>mdi-purse</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('qualitycheck.product.production')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
      <v-card-text>
        <div class="font-weight-bold ml-4 mb-2">
          {{$t('global.timeline')}}
        </div>
        <v-timeline align-top  dense>
          <v-timeline-item
            v-for="product in products"
            :key="product.id"
            :color="colorProduct(product.delivery)"
            small
          >
            <button class="text-left" @click="showHandler(product)">
              <div>
                <strong> {{ formatDate(product.delivery, 'long') }}</strong> Ref:{{ product.orderFab }}
              </div>
              <div ><v-icon dense>{{ logoProduct(product.type)}}</v-icon> <span  >{{ product.name }}</span></div>
            </button>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import moment from 'moment';

export default {
  name: 'ProductList',
  servicePrefix: 'Product',
  mixins: [ListMixin],
  components: {

  },
  data() {
    return {
    };
  },
  mounted() {
      this.productstatusGetSelectItems();
  },
  computed: {
    ...mapGetters('product', {
      products: 'list'
    }),
    ...mapFields('product', {
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapFields('productstatus', {
      statusSelectItems: 'selectItems',
      isLoading_productstatus : 'isLoading'
    }),
  },
  methods: {
    ...mapActions('product', {
      getProducts: 'fetchAll'
    }),
    ...mapActions({
      productstatusGetSelectItems: 'productstatus/fetchSelectItems'
    }),
    logoProduct(type) {
      switch(type) {
        case 'Machine':
          return 'mdi-printer-3d';
        case 'Toolhead':
          return 'mdi-tools';
        case 'Material supply':
          return 'mdi-format-color-fill';
        case 'Control Unit':
          return 'mdi-car-cruise-control';
        case 'Industrial computer':
          return 'mdi-server';
        case 'Accessory':
          return 'mdi-cctv';
        case 'Option':
          return 'mdi-toy-brick-plus';
        default:
          return 'mdi-purse';
      }
    },
    colorProduct(delivery) {
      if (!delivery)  return 'primary';
      var date = new Date(moment(delivery).format('YYYY/MM/DD'));
      var d1 = new Date();
      d1.setDate(d1.getDate()+10);
      var d2 = new Date();
      d2.setDate(d2.getDate()+30);
      if (date < d1) {
        return 'red';
      }
      if (date < d2) {
        return 'primary';
      }
      if (date) {
        return 'green';
      }
      return 'primary';
    },
  },
  watch: {
    statusSelectItems() {
      if(this.statusSelectItems) {
        let filters = [];
        for (let i = 0; i < this.statusSelectItems.length; i++) {
          if (this.statusSelectItems[i]['name'] != 'Delivered')  {
            //filters.push({'id': 'status_OrQuery', 'value': this.statusSelectItems[i]['@id'] });
            filters.push( this.statusSelectItems[i]['@id'] );
          }
        }
        this.getProducts({'status': filters,'itemsPerPage': '20','order[delivery]': 'asc'});
      }


    },
  }
};
</script>
